import React from "react";
import { Table, Form } from "antd";
import { Button, Message, Input, Popconfirm } from "../../BP2Components";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { setTranslations } from "../../../appRedux/actions/Actions";
import Widget from "../../Widget/Widget";
import IntlMessages from "@util/IntlMessages";
import {
   getAllTranslations,
   postNewTranslation,
   editTranslations,
   deleteTranslation,
} from "../../../services/restAPI/RestApi";
import TranslationSettings from "../../Translations/TranslationsSettings";
import SettingsModal from "../../Modal/SettingsModal";
import { changeTranslationRecordToRequestData, updateTranslationsUsage } from "@util/Scripts";
import "../../Translations/translations.less";
import { Icon_Plus2, Icon_Search } from "../../BP2Components/Icons/icons";
import Select from "react-select";
import projectTableRaw from "../../../projectTable.json";

const scrollX = 1700;
const colWidth = {
   addBtn: 70,
   langKey: 350,
   category: 180,
   pl: 200,
   en: 200,
   de: 200,
   sp: 200,
   scope: 175,
   actions: 110,
};
const projectTable = ["__default", ...projectTableRaw];

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
   <EditableContext.Provider value={form}>
      <tr {...props} />
   </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
   constructor(props) {
      super(props);
      this.newRef = React.createRef();
   }
   state = {
      editing: false,
   };

   toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
         if (editing) {
            this.newRef.current.focus();
         }
      });
   };

   save = (e) => {
      const { record, handleInputChange } = this.props;
      this.form.validateFields((error, values) => {
         if (error && error[e.currentTarget.id]) {
            return;
         }
         this.toggleEdit();
         handleInputChange({ ...record, ...values });
      });
   };

   renderCell = (form) => {
      this.form = form;
      const { children, dataIndex, record, title } = this.props;
      const { editing } = this.state;
      return editing ? (
         <Form.Item style={{ margin: 0 }}>
            {form.getFieldDecorator(dataIndex, {
               rules: [
                  {
                     required: true,
                     message: `${title} is required.`,
                  },
               ],
               initialValue: record[dataIndex],
            })(<Input ref={this.newRef} onPressEnter={this.save} onBlur={this.save} />)}
         </Form.Item>
      ) : (
         <div
            className="editable-cell-value-wrap"
            style={{ paddingRight: 24 }}
            onClick={this.toggleEdit}
         >
            {children}
         </div>
      );
   };

   render() {
      const {
         editable,
         dataIndex,
         title,
         record,
         index,
         handleInputChange,
         children,
         ...restProps
      } = this.props;
      return (
         <td {...restProps}>
            {editable ? (
               <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
            ) : (
               children
            )}
         </td>
      );
   }
}

class Translations extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         columns: [],
         dataSource: [],
         count: 0,
         firstElement: {},
         expandedRowKeys: [],
         isLoading: true,
      };
   }

   getConstantColumns = (useScopeSelect, firstElement) => {
      const { intl } = this.props;
      const columnsToRender = [];

      columnsToRender.push({
         title: "",
         dataIndex: "addBtn",
         editable: false,
         width: colWidth.addBtn,
         render: (_text, record) => {
            if (record.newItem || useScopeSelect) return null;
            return (
               <div className="list-widget-table-header-actions">
                  <Button
                     buttonType="primary"
                     onClick={() => this.handleAddExpand(record)}
                     className="add-button"
                  >
                     <Icon_Plus2 fill="var(--btn-primaryText)" />
                  </Button>
               </div>
            );
         },
      });
      Object.keys(firstElement).forEach((column) => {
         if (column !== "translations") {
            columnsToRender.push({
               title: this.props.intl.formatMessage({ id: `translations.${column}` }),
               dataIndex: column,
               editable: true,
               width: column === "langKey" ? colWidth.langKey : colWidth.category,

               ...this.getColumnSearchProps(column),
            });
         }
      });

      const baseColumns = (this.props.allLanguages ?? []).map(({ language }) => ({
         title: language.toUpperCase(),
         dataIndex: language,
         editable: true,
         width: colWidth[language] ?? 200,
         ...this.getColumnSearchProps(language),
      }));
      columnsToRender.push(...baseColumns);
      const options = projectTable.map((project) => ({ label: project, value: project }));
      const scopeColumn = {
         title: intl.formatMessage({ id: `translations.scope` }),
         dataIndex: "scope",
         editable: false,
         width: colWidth.scope,
         render: (_text, record) => (
            <div className="translations-actions-btn" style={{ display: "grid" }}>
               <Select
                  value={record.scope}
                  isDisabled={!record.newItem && !record.newExpandItem}
                  onChange={(value) => {
                     if (useScopeSelect) {
                        this.handleInnerScopeChange(record, value);
                     } else {
                        this.handleInputChange({
                           ...record,
                           scope: value,
                        });
                     }
                  }}
                  options={options}
                  menuPlacement={record.newExpandItem ? "top" : "bottom"}
                  maxMenuHeight={130}
               />
            </div>
         ),
      };
      columnsToRender.push(scopeColumn);
      columnsToRender.push({
         title: "",
         dataIndex: "actions",
         width: colWidth.actions,
         editable: false,
         render: (_text, record) => (
            <div className="translations-actions-btn" style={{ display: "grid", gap: "12px" }}>
               <>
                  <Button
                     buttonType="primary"
                     block
                     style={{ maxWidth: 65 }}
                     onClick={() => this.handleSave(record)}
                  >
                     <IntlMessages id="global.save" />
                  </Button>
                  <Popconfirm
                     title={this.props.intl.formatMessage({ id: "settings.sureToDelete" })}
                     onConfirm={() => this.handleDelete(record)}
                  >
                     <Button buttonType="danger" style={{ minWidth: 65 }} block>
                        <IntlMessages id="global.delete" />
                     </Button>
                  </Popconfirm>
               </>
            </div>
         ),
      });

      return columnsToRender;
   };

   hasNonDefaultScopes = (row) =>
      Array.isArray(row.translations) &&
      row.translations.some((translation) => translation.scope !== "__default");

   componentDidMount() {
      if (!projectTable.length) {
         this.setState({ isLoading: false });
         return;
      }
      getAllTranslations()
         .then((res) => {
            if (!res.data?.length) {
               this.setState({
                  dataSource: [],
                  columns: this.getConstantColumns(false, { langKey: "", category: "" }),
                  isLoading: false,
               });
               return;
            }
            const constantColumns = this.getConstantColumns(false, res.data?.[0]);

            const dataToShow = res.data.map((singleTranslation) => {
               const currentTranslationObject = {};

               const allTranslations = singleTranslation.translations ?? [];

               const defaultScopeTranslations = allTranslations.filter(
                  (translation) => translation.scope === "__default",
               );

               let translationsForMainRow;
               let scopeForMainRow;
               if (defaultScopeTranslations.length > 0) {
                  translationsForMainRow = defaultScopeTranslations;
                  scopeForMainRow = "__default";
               } else {
                  scopeForMainRow = allTranslations[0]?.scope ?? "__default";
                  translationsForMainRow = allTranslations.filter(
                     (translation) => translation.scope === scopeForMainRow,
                  );
               }

               currentTranslationObject.langKey = singleTranslation.langKey;
               currentTranslationObject.category = singleTranslation.category;

               translationsForMainRow.forEach((translation) => {
                  currentTranslationObject[translation.language] = translation.value;
               });

               currentTranslationObject.scope = {
                  value: scopeForMainRow,
                  label: scopeForMainRow,
               };
               currentTranslationObject.key = singleTranslation.langKey;
               currentTranslationObject.translations = singleTranslation.translations;

               return currentTranslationObject;
            });

            const expandedRowKeys = dataToShow
               .filter(this.hasNonDefaultScopes)
               .map((row) => row.key);

            this.setState({
               columns: constantColumns,
               dataSource: dataToShow,
               firstElement: res.data[0],
               expandedRowKeys,
               isLoading: false,
            });
         })
         .catch((err) => {
            console.error(err);
            this.setState({ isLoading: false });
            Message.error(
               this.props.intl.formatMessage({ id: "translations.errorInLoadingTranslations" }),
            );
         });
   }

   getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={(node) => {
                  this.searchInput = node;
               }}
               placeholder={this.props.intl.formatMessage({ id: "filter.search" })}
               value={selectedKeys[0]}
               onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
               buttonType="primary"
               onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
               icon="search"
               size="small"
               style={{ width: 90, marginRight: 8 }}
            >
               <IntlMessages id="filter.search" />
            </Button>
            <Button
               buttonType="primary"
               onClick={() => this.handleReset(clearFilters)}
               size="small"
               style={{ width: 90 }}
            >
               <IntlMessages id="filter.reset" />
            </Button>
         </div>
      ),
      filterIcon: () => (
         <i>
            <Icon_Search fill="none" stroke="#64748B" />
         </i>
      ),
      onFilter: (value, record) =>
         !!record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
         if (visible) {
            setTimeout(() => this.searchInput.select());
         }
      },
      render: (text) => text,
   });

   // FILTERING
   handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({
         searchText: selectedKeys[0],
         searchedColumn: dataIndex,
      });
   };

   handleReset = (clearFilters) => {
      clearFilters();
      this.setState({ searchText: "" });
   };

   handleAdd = () => {
      const { count, dataSource } = this.state;
      const newData = {
         key: count,
         langKey: `New translation ${count}`,
         category: "-",
         newItem: true,
         scope: { value: "__default", label: "__default" },
      };

      this.props.allLanguages.forEach(({ language }) => (newData[language] = "-"));

      this.setState({
         dataSource: [newData, ...dataSource],
         count: count + 1,
      });
   };

   handleAddExpand = (parentRow) => {
      this.setState((prev) => {
         const data = [...prev.dataSource];

         const parentIndex = data.findIndex((item) => item.langKey === parentRow.langKey);
         if (parentIndex === -1) return prev;

         const parent = { ...data[parentIndex] };
         const translations = Array.isArray(parent.translations) ? [...parent.translations] : [];

         const langs = this.props.allLanguages.map(({ language }) => language);
         const tempScope = `__temp_${Date.now()}`;

         const newEmptyTranslations = langs.map((lang) => ({
            id: null,
            language: lang,
            value: "-",
            newExpandItem: true,
            scope: tempScope,
         }));

         parent.translations = [...translations, ...newEmptyTranslations];

         data[parentIndex] = parent;

         return {
            dataSource: data,
            expandedRowKeys: Array.from(new Set([...(prev.expandedRowKeys || []), parent.key])),
         };
      });
   };

   handleInnerScopeChange = (row, option) => {
      const scopeValue = option?.value || option;

      this.setState((prev) => {
         const data = [...prev.dataSource];

         const parentIndex = data.findIndex((item) => item.langKey === row.langKey);
         if (parentIndex === -1) return prev;

         const parent = { ...data[parentIndex] };
         if (!Array.isArray(parent.translations)) return prev;

         const updatedTranslations = parent.translations.map((translation) => {
            if (
               translation.newExpandItem &&
               (translation.scope == null || translation.scope === row.scope?.value)
            ) {
               return {
                  ...translation,
                  scope: scopeValue,
               };
            }
            return translation;
         });

         parent.translations = updatedTranslations;
         data[parentIndex] = parent;

         return { dataSource: data };
      });
   };

   handleSave = (record) => {
      const properData = changeTranslationRecordToRequestData({
         ...record,
      });
      const rowKey = record.key || record.langKey;

      if (record.newItem) {
         if (!record?.langKey?.includes("New translation")) {
            Message.loading(this.props.intl.formatMessage({ id: "global.loading" }), 0);
            postNewTranslation(properData)
               .then(() => {
                  updateTranslationsUsage(this.props.intl);
                  this.setState((prev) => ({
                     expandedRowKeys: Array.from(
                        new Set([...(prev.expandedRowKeys || []), rowKey]),
                     ),
                  }));
               })
               .catch(() => {
                  Message.destroy();
                  Message.error(
                     this.props.intl.formatMessage({ id: "translations.errorInAddingTranslation" }),
                  );
               });
         } else {
            Message.destroy();
            Message.error(
               this.props.intl.formatMessage({ id: "translations.changeDefaultValues" }),
            );
         }
      } else {
         editTranslations(properData)
            .then(() => updateTranslationsUsage(this.props.intl))
            .catch(() => {
               Message.destroy();
               Message.error(
                  this.props.intl.formatMessage({ id: "translations.errorInAddingTranslation" }),
               );
            });
      }
   };

   handleDelete = (record) => {
      const { langKey, key, scope } = record;
      const translationScope = scope.label;
      Message.loading(this.props.intl.formatMessage({ id: "global.loading" }), 0);
      deleteTranslation(langKey, translationScope)
         .then(() => {
            updateTranslationsUsage(this.props.intl);
            const dataSource = [...this.state.dataSource];
            this.setState({ dataSource: dataSource.filter((item) => item.key !== key) });
         })
         .catch((error) => {
            Message.destroy();

            Message.error(
               error?.response?.data?.message
                  ? this.props.intl.formatMessage({ id: `error.${error.response.data.message}` })
                  : this.props.intl.formatMessage({ id: "translations.errorWhileDeletingRecord" }),
               5000,
            );
         });
   };

   handleInputChange = (row) => {
      const newData = [...this.state.dataSource];
      const index = newData.findIndex((item) => row.key === item.key);
      const item = newData[index];
      newData.splice(index, 1, {
         ...item,
         ...row,
      });

      this.setState({ dataSource: newData });
   };

   handleInnerInputChange = (row) => {
      this.setState((prevState) => {
         const newData = [...prevState.dataSource];

         const parentIndex = newData.findIndex((item) => item.langKey === row.langKey);
         if (parentIndex === -1) return prevState;

         const parent = { ...newData[parentIndex] };
         const scopeValue = row.scope?.value || row.scope?.label || row.scope;
         const langs = this.props.allLanguages.map(({ language }) => language);

         if (!Array.isArray(parent.translations)) {
            return prevState;
         }

         const updatedTranslations = parent.translations.map((translation) => {
            if (translation.scope !== scopeValue) return translation;

            const newValForLang = row[translation.language];
            if (newValForLang === undefined) return translation;
            return {
               ...translation,
               id: translation.id,
               value: newValForLang,
            };
         });

         const updatedParent = { ...parent, translations: updatedTranslations };

         if (scopeValue === "__default") {
            updatedTranslations.forEach((t) => {
               if (langs.includes(t.language)) {
                  updatedParent[t.language] = t.value;
               }
            });
         }

         newData[parentIndex] = updatedParent;
         return { dataSource: newData };
      });
   };

   render() {
      const { dataSource } = this.state;
      const components = {
         body: {
            row: EditableFormRow,
            cell: EditableCell,
         },
      };
      const columns = this.state.columns.map((col) => {
         if (!col.editable) {
            return col;
         }
         return {
            ...col,
            onCell: (record) => ({
               record,
               editable: col.editable,
               dataIndex: col.dataIndex,
               title: col.title,
               handleInputChange: this.handleInputChange,
            }),
         };
      });

      const normalizeScope = (scope) => {
         if (scope == null) return null;
         if (scope === "") return null;
         if (scope === "null" || scope === "undefined") return null;
         return scope;
      };

      const isEmptyScope = (scope) =>
         scope == null || scope === "" || scope === "null" || scope === "undefined";

      const expandedRowRender = (row) => {
         if (!Array.isArray(row.translations) || row.translations.length === 0) {
            return null;
         }

         const nonDefault = row.translations.filter(
            (translation) => translation.scope !== "__default",
         );

         if (nonDefault.length === 0) return null;

         const groupedByScope = nonDefault.reduce((acc, item) => {
            const { scope } = item;
            if (!acc[scope]) acc[scope] = [];
            acc[scope].push(item);
            return acc;
         }, {});

         const sortedScopes = Object.keys(groupedByScope).sort((a, b) => {
            const aEmpty = isEmptyScope(a);
            const bEmpty = isEmptyScope(b);

            if (aEmpty && !bEmpty) return 1;
            if (!aEmpty && bEmpty) return -1;

            return a.localeCompare(b);
         });

         const data = sortedScopes.map((scopeRaw, index) => {
            const items = groupedByScope[scopeRaw];
            const scope = normalizeScope(scopeRaw);
            const rowData = {
               key: `${row.langKey}-${scope}-${index}`,
               langKey: row.langKey,
               category: row.category,
               scope: scope ? { label: scope, value: scope } : null,
               translations: items,
               newExpandItem: items.some((translation) => translation.newExpandItem),
            };

            const langs = this.props.allLanguages.map(({ language }) => language);
            langs.forEach((lang) => {
               rowData[lang] = "-";
            });

            items.forEach((translation) => {
               if (langs.includes(translation.language)) {
                  rowData[translation.language] = translation.value ?? "-";
               }
            });

            return rowData;
         });

         let innerColumns = this.getConstantColumns(true, this.state.firstElement).map((col) => {
            if (!col.editable) {
               return col;
            }
            return {
               ...col,
               onCell: (record) => ({
                  record,
                  editable: col.editable,
                  dataIndex: col.dataIndex,
                  title: col.title,
                  handleInputChange: this.handleInnerInputChange,
               }),
            };
         });

         innerColumns = innerColumns.map((col) => {
            if (col.dataIndex === "langKey" || col.dataIndex === "category") {
               return {
                  ...col,
                  editable: false,
                  render: () => null,
               };
            }
            return col;
         });

         return (
            <Table
               components={components}
               rowClassName={() => "editable-row"}
               bordered={false}
               columns={innerColumns}
               dataSource={data}
               pagination={false}
               showHeader={false}
               className="expandable-table"
               tableLayout="fixed"
               scroll={{ x: scrollX }}
            />
         );
      };

      return (
         <Widget
            bgColor={this.props.value.backgroundColourHex}
            role={this?.props?.role}
            extra={
               this.props.role === "OWNER" || this.props.role === "MODERATOR" ? (
                  <SettingsModal
                     widgetId={this.props.value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={
                        <TranslationSettings
                           id={this.props.value.id}
                           name={this.props.value.widgetName}
                           visibleDeleteTranslation={this.props.value.visibleDeleteTranslation}
                           visibleAddTranslation={this.props.value.visibleAddTranslation}
                           columns={this.props.value.columns}
                           xs={this.props.value.xsWidth}
                           sm={this.props.value.smWidth}
                           md={this.props.value.mdWidth}
                           lg={this.props.value.lgWidth}
                           xl={this.props.value.xlWidth}
                           backgroundColourHex={this.props.value.backgroundColourHex}
                           priority={this.props.value.priority}
                        />
                     }
                  />
               ) : null
            }
         >
            <div className="translation-container" style={{ position: "relative" }}>
               <Button buttonType="primary" onClick={this.handleAdd}>
                  <IntlMessages id="translations.addTranslation" />
               </Button>
               <div className="translations-table" style={{ overflow: "scroll" }}>
                  <Table
                     className="translations-table-root"
                     components={components}
                     rowClassName={() => "editable-row"}
                     bordered={false}
                     dataSource={dataSource}
                     expandedRowRender={(row) => expandedRowRender(row)}
                     expandedRowKeys={this.state.expandedRowKeys}
                     expandIcon={() => null}
                     columns={columns}
                     pagination={{ pageSize: 50 }}
                     loading={this.state.isLoading}
                     tableLayout="fixed"
                     expandIconAsCell={false}
                     scroll={{ x: scrollX }}
                  />
               </div>
            </div>
         </Widget>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      locale: state.settings.locale,
      allLanguages: state.settings.allLanguages,
   };
};

export default connect(mapStateToProps, { setTranslations })(injectIntl(Translations));
